import React, { PureComponent, useState } from "react";
import { Marker } from "react-map-gl";
import { useTransition } from "react-spring";

const ICON = `M20.2,15.7L20.2,15.7c1.1-1.6,1.8-3.6,1.8-5.7c0-5.6-4.5-10-10-10S2,4.5,2,10c0,2,0.6,3.9,1.6,5.4c0,0.1,0.1,0.2,0.2,0.3
  c0,0,0.1,0.1,0.1,0.2c0.2,0.3,0.4,0.6,0.7,0.9c2.6,3.1,7.4,7.6,7.4,7.6s4.8-4.5,7.4-7.5c0.2-0.3,0.5-0.6,0.7-0.9
  C20.1,15.8,20.2,15.8,20.2,15.7z`;

const SIZE = 38;

// Important for perf: the markers never change, avoid rerender when the map viewport changes
export default class Pins extends PureComponent {
  render() {
    const { data, onClick } = this.props;
    return data.map((city, index) => {
      const number = Math.ceil(Math.random() * 6);
      return (
        <MyMarker
          key={`marker-${index}`}
          longitude={city.lng}
          latitude={city.lat}
          _onClick={onClick}
          city={city}
        />
      );
    });
  }
}

const MyMarker = (props) => {
  const { _onClick, city, longitude, latitude } = props;
  const [num, setNum] = useState(Math.ceil(Math.random() * 6));
  const [show, set] = useState(false);
  const transitions = useTransition(show, null, {
    from: { position: "absolute", opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });
  // return transitions.map(({ item, key, props }) =>
  // item && <animated.div key={key} style={props}>✌️</animated.div>
  // )
  return (
    <Marker longitude={longitude} latitude={latitude} onClick={_onClick}>
      <svg
        height={SIZE}
        viewBox="0 0 48 48"
        style={{
          cursor: "pointer",
          fill: "#d00",
          stroke: "none",
          transform: `translate(${-SIZE / 2}px,${-SIZE}px)`,
          color: "green",
        }}
        onClick={() => _onClick(city)}
      >
        <path
          d={ICON}
          fill={
            city.concentration < 1400
              ? "#66bb6a"
              : city.concentration < 1950
              ? "#fbc02d"
              : "#c62828"
          }
          strokeLinecap="round"
          style={{ transform: "scale(1.6)" }}
        />
      </svg>
    </Marker>
  );
};
